import Drawer from "@mui/material/Drawer";
import React, { useState, useEffect } from "react";
import { Grid, Chip, Button, TextField, Box } from "@mui/material";
import Table from "components/common/Table";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";

const KeywordsDrawer = ({
  open,
  onClose,
  data,
  onKeywordAdd,
  onKeywordDelete,
  onKeywordUpdate,
  isLoading,
}) => {
  const [value, setValue] = useState("");
  const [is_update, setIsUpdate] = useState(false);
  const [keywordEdit, setKeywordEdit] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const handleInputChange = (e) => {
    setValue(e.target.value);
  };

  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
  };

  const filteredData = data.filter((keyword) =>
    keyword.name.toLowerCase().includes(searchValue.toLowerCase())
  );

  const handleAddKeyword = () => {
    setValue("");
    setIsUpdate(false);
    setKeywordEdit("");
  };

  useEffect(() => {
    setKeywordEdit("");
    setIsUpdate(false);
    setValue("");
  }, [data]);

  const columns = [
    {
      field: "name",
      headerName: data.length ? "Click on keyword to edit" : "Keywords",
      valueGetter: (v, d) => {
        return (
          <>
            <Chip
              label={v}
              variant="outlined"
              size="small"
              sx={{ fontSize: "14px" }}
              onDelete={() => {
                setValue(v);
                setKeywordEdit(d.id);
                setIsUpdate(true);
              }}
              deleteIcon={<EditIcon />}
            />
          </>
        );
      },
    },
    {
      field: "delete",
      headerName: "Action",
      valueGetter: (v, d) => {
        return (
          <>
            <DeleteIcon
              onClick={() => onKeywordDelete(d.id)}
              sx={{ fontSize: "18px", cursor: "pointer" }}
            />
          </>
        );
      },
    },
  ];

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiDrawer-paper": { boxSizing: "border-box", width: 450 },
      }}
    >
      {value ? (
        <CloseIcon
          onClick={() => {
            setValue("");
            setIsUpdate(false);
            setKeywordEdit("");
          }}
          sx={{
            width: "22px",
            position: "absolute",
            top: "10px",
            right: "1rem",
            cursor: "pointer",
            background: "white",
            color: "green",
          }}
        />
      ) : null}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: 2,
          marginTop: "1rem",
        }}
      >
        <TextField
          fullWidth
          size="small"
          value={value}
          onChange={handleInputChange}
          inputProps={{ style: { fontSize: "14px" } }}
          label={is_update ? "Update Keyword" : "Add Keyword"}
          sx={{
            fontSize: "14px",
            width: "75%",
          }}
          variant="outlined"
          margin="dense"
        />
        <Button
          type="submit"
          disableElevation
          variant="contained"
          size="small"
          disabled={!value}
          onClick={() => {
            is_update
              ? onKeywordUpdate({ name: value, id: keywordEdit })
              : onKeywordAdd(value);
            handleAddKeyword();
          }}
        >
          {is_update ? "Save" : "Add"}
        </Button>
      </Box>

      <Box sx={{ p: 2 }}>
        <TextField
          fullWidth
          size="small"
          value={searchValue}
          onChange={handleSearchChange}
          inputProps={{ style: { fontSize: "14px" } }}
          label="Search Keywords"
          sx={{
            fontSize: "14px",
          }}
          variant="outlined"
          margin="dense"
          InputProps={{
            endAdornment: (
              <SearchIcon
                sx={{
                  color: "rgba(0, 0, 0, 0.54)",
                  fontSize: "20px",
                }}
              />
            ),
          }}
        />
      </Box>

      <Grid container spacing={1} sx={{ p: 2 }}>
        <Table
          columns={columns}
          data={filteredData}
          isLoading={isLoading}
          pagination={true}
          localPagination={true}
          page={0}
          rowsPerPage={5}
        />
      </Grid>
    </Drawer>
  );
};

export default KeywordsDrawer;
